/* ODCAF Express — simpler ordering on product pages:
   1) numbered steps (headings marked data-odx-step, plus a final "Review & add to cart" step)
   2) price shown on each quantity choice (or on each size, for per-piece products)
   3) running total on the Add to cart button (includes the design add-on when ticked)
   Loaded by the Odcaf FAQ section, so it runs on the rebuilt product pages only. */
(function () {
  var css = '' +
    '.odx-pdp-h[data-odx-step]{display:flex;align-items:center;gap:10px}' +
    '.odx-pdp-h[data-odx-step]::before{content:attr(data-n);flex:none;width:26px;height:26px;border-radius:50%;background:#0d0d1a;color:#fff;font-size:13px;font-weight:800;line-height:1;display:inline-flex;align-items:center;justify-content:center}' +
    '.odx-flow-final .odx-pdp-h{margin-bottom:10px !important}' +
    'fieldset.odx-qfs.is-qty{display:grid !important;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px}' +
    'fieldset.odx-qfs.is-qty input[type=radio]+label{display:flex !important;flex-direction:column;align-items:center;justify-content:center;gap:1px;margin:0 !important;border-radius:10px !important;padding:9px 4px !important;line-height:1.2;text-align:center;min-width:0}' +
    'fieldset.odx-qfs.is-size input[type=radio]+label{display:inline-flex !important;flex-direction:column;align-items:center;line-height:1.2;padding-top:7px !important;padding-bottom:7px !important}' +
    '.odx-qp{display:block;font-weight:800;font-size:14px;margin-top:2px}' +
    '.odx-qp small{display:block;font-weight:500;font-size:11px;opacity:.72}' +
    'fieldset.odx-qfs.is-size .odx-qp{font-size:12.5px}' +
    '.odx-link[data-odx-link]{display:block;white-space:normal;margin-top:14px;padding:12px 14px;border:1.5px solid #e8e8ef;border-radius:12px;background:#fff}' +
    '.odx-link label{display:block;font-weight:700;font-size:13.5px;margin:0 0 6px}' +
    '.odx-link label small{font-weight:500;color:#5b5d6b}' +
    '.odx-link input{width:100%;box-sizing:border-box;border:1.5px solid #d6d7e0;border-radius:10px;padding:10px 12px;font:inherit;font-size:14px;background:#f7f7fa}' +
    '.odx-link input:focus{outline:none;border-color:#d4147f;background:#fff}' +
    '.odx-link.is-bad input{border-color:#a3122f}' +
    '.odx-link__hint{margin:6px 0 0 !important;font-size:12px;color:#5b5d6b;line-height:1.45}' +
    '.odx-link__or{display:flex;align-items:center;gap:10px;margin:14px 0 0 !important;font-size:12px;font-weight:700;color:#5b5d6b;text-transform:uppercase;letter-spacing:.06em}' +
    '.odx-link__or::before,.odx-link__or::after{content:"";flex:1;height:1px;background:#e8e8ef}' +
    '.odx-btn-total{margin-left:.35em;font-weight:800}' +
    '.odx-free-note{margin:8px 0 0 !important;font-size:13px;font-weight:700;color:#17693a;text-align:center}' +
    '@media (max-width:749px){fieldset.odx-qfs.is-qty{grid-template-columns:repeat(2,minmax(0,1fr))}}';

  function addStyle() {
    if (document.getElementById('odx-flow-css')) return;
    var st = document.createElement('style');
    st.id = 'odx-flow-css';
    st.textContent = css;
    document.head.appendChild(st);
  }

  function init(cfg) {
    var sid = cfg.sid;
    var form = document.getElementById('product-form-' + sid);
    if (!form) return;
    var fmt;
    try { fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: cfg.currency || 'USD' }); } catch (e) { fmt = null; }
    function money(c) { var s = fmt ? fmt.format(c / 100) : '$' + (c / 100).toFixed(2); return s.replace(/\.00$/, ''); }
    function each(c, q) {
      var per = c / q;
      if (per < 100) return (Math.round(per * 10) / 10) + '¢ each';
      return money(Math.round(per)) + ' each';
    }
    var byId = {};
    cfg.variants.forEach(function (v) { byId[v.id] = v; });
    function current() {
      var i = form.querySelector('input[name="id"]');
      var base = (i && byId[i.value]) || cfg.variants[0];
      /* custom size (odcaf-print.js): show its calculated price instead of the selected size's */
      var c = form.__odxCustom;
      if (c && c.on && c.ok && c.price) return { id: base.id, p: c.price, o: base.o };
      return base;
    }
    function findVariant(opts) {
      for (var i = 0; i < cfg.variants.length; i++) {
        var v = cfg.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) if (v.o[j] !== opts[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    var info = form.closest('.product__info-container') || form.closest('section') || document.body;
    var atc = form.querySelector('[name="add"]');
    var productForm = form.closest('product-form') || form;
    function visible(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }

    /* 1 — numbered steps */
    function steps() {
      var fin = info.querySelector('[data-odx-flow-final]');
      var show = visible(atc);
      if (show && !fin) {
        fin = document.createElement('div');
        fin.className = 'odx-pdp odx-flow-final';
        fin.setAttribute('data-odx-flow-final', '');
        fin.innerHTML = '<p class="odx-pdp-h" data-odx-step>' + (cfg.finalLabel || 'Review &amp; add to cart') + '</p>';
        productForm.parentNode.insertBefore(fin, productForm);
      }
      if (fin) fin.hidden = !show;
      var n = 0;
      Array.prototype.forEach.call(info.querySelectorAll('[data-odx-step]'), function (h) {
        if (h.closest('[hidden]') || !visible(h)) return;
        var k = String(++n);
        if (h.getAttribute('data-n') !== k) h.setAttribute('data-n', k);
      });
    }

    /* 2 — prices on the choices */
    var qIdx = -1, sIdx = -1;
    cfg.options.forEach(function (name, i) { if (/^(quantity|qty)\W*$/i.test(name)) qIdx = i; });
    if (qIdx < 0) {
      /* no quantity option: label the one option whose values change the price (e.g. transfer size) */
      var varying = cfg.options.map(function (name, i) {
        var seen = {};
        return cfg.variants.some(function (v) {
          var key = v.o.filter(function (x, j) { return j !== i; }).join('|');
          if (seen[key] === undefined) { seen[key] = v.p; return false; }
          return seen[key] !== v.p;
        });
      });
      var count = varying.filter(Boolean).length;
      if (count === 1) sIdx = varying.indexOf(true);
    }
    var picker = document.querySelector('variant-radios[data-section="' + sid + '"]');
    function labels() {
      var idx = qIdx >= 0 ? qIdx : sIdx;
      if (!picker || idx < 0) return;
      var name = cfg.options[idx];
      var cur = current();
      var inputs = picker.querySelectorAll('input[type="radio"]');
      Array.prototype.forEach.call(inputs, function (inp) {
        if (inp.name !== name) return;
        var fs = inp.closest('fieldset');
        if (fs && !fs.classList.contains('odx-qfs')) fs.classList.add('odx-qfs', qIdx >= 0 ? 'is-qty' : 'is-size');
        var opts = cur.o.slice(); opts[idx] = inp.value;
        var v = findVariant(opts);
        var lab = picker.querySelector('label[for="' + inp.id + '"]');
        if (!lab) return;
        var sp = lab.querySelector('.odx-qp');
        if (!sp) { sp = document.createElement('span'); sp.className = 'odx-qp'; lab.appendChild(sp); }
        var html = '';
        if (v) {
          html = money(v.p);
          var q = parseInt(String(inp.value).replace(/[^\d]/g, ''), 10);
          if (qIdx >= 0 && q > 0) html += '<small>' + each(v.p, q) + '</small>';
        }
        if (sp.innerHTML !== html) sp.innerHTML = html;
      });
    }

    /* 3 — total on the button */
    var qtyInput = document.getElementById('Quantity-' + sid);
    function total() {
      var design = document.querySelector('[data-odx-design]');
      if (!atc) return;
      var v = current();
      var n = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (!n || n < 1) n = 1;
      var t = v.p * n;
      if (design && design.checked) t += parseInt(design.getAttribute('data-price'), 10) || 0;
      Array.prototype.forEach.call(info.querySelectorAll('input[data-odx-addon]:checked:not(:disabled)'), function (a) {
        var ap = parseInt(a.getAttribute('data-price'), 10) || 0;
        t += a.hasAttribute('data-once') ? ap : ap * n;
      });
      var pe = info.querySelector('[data-odx-price]');
      if (pe && pe.hasAttribute('data-odx-live')) { var pt = money(v.p); if (pe.textContent !== pt) pe.textContent = pt; }
      var fe = info.querySelector('[data-odx-for][data-tpl]');
      if (fe) {
        var qv = qIdx >= 0 ? String(v.o[qIdx]) : '';
        var qn = parseInt(qv.replace(/[^\d]/g, ''), 10);
        var ft = fe.getAttribute('data-tpl').replace('{q}', qv).replace('{s}', qn === 1 ? '' : 's').replace('{es}', qn === 1 ? '' : 'es');
        if (qn > 0 && fe.hasAttribute('data-each')) ft += ' · ' + each(v.p, qn);
        if (fe.textContent !== ft) fe.textContent = ft;
      }
      var sp = atc.querySelector('.odx-btn-total');
      if (!sp) { sp = document.createElement('span'); sp.className = 'odx-btn-total'; var first = atc.querySelector(':scope > span'); if (first) first.after(sp); else atc.appendChild(sp); }
      var txt = atc.disabled ? '' : '· ' + money(t);
      if (sp.textContent !== txt) sp.textContent = txt;
      /* Buy X get 1 free (DTF yards): the discount comes off at checkout */
      if (cfg.everyFree > 1) {
        var note = productForm.parentNode.querySelector('.odx-free-note');
        var free = Math.floor(n / cfg.everyFree);
        if (free && !note) { note = document.createElement('p'); note.className = 'odx-free-note'; productForm.after(note); }
        if (note) {
          var nt = free ? '✓ ' + free + (free === 1 ? ' free yard' : ' free yards') + ' (−' + money(v.p * free) + ') comes off at checkout — you pay ' + money(t - v.p * free) : '';
          if (note.textContent !== nt) note.textContent = nt;
          note.hidden = !free;
        }
      }
    }

    function all() { steps(); labels(); total(); }
    var timer;
    function soon() { clearTimeout(timer); timer = setTimeout(all, 80); }
    document.addEventListener('change', soon);
    document.addEventListener('input', function (e) { if (e.target === qtyInput) soon(); });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.quantity__button, .odt-cell')) soon(); });
    if (window.MutationObserver) {
      new MutationObserver(soon).observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'hidden', 'style', 'class'] });
    }
    all();
    setTimeout(all, 600);
    setTimeout(all, 2000);
  }

  /* Print & Press designer: show its running total on its own Add to cart button */
  function ppTotal() {
    var tot = document.querySelector('[data-pp-total]');
    var btn = document.querySelector('[data-pp-submit] > span');
    if (!tot || !btn || window.__odxPP) return;
    window.__odxPP = true;
    function sync() {
      var t = tot.textContent.trim();
      var txt = t ? 'Add to cart · ' + t : 'Add to cart';
      if (btn.textContent !== txt) btn.textContent = txt;
    }
    new MutationObserver(sync).observe(tot, { childList: true, characterData: true, subtree: true });
    sync();
  }

  /* "Paste a link to your file" (Canva, Google Drive, Dropbox, WeTransfer) — saved on the order as "Artwork link" */
  function linkBox(formId, intro) {
    var d = document.createElement('div');
    d.className = 'odx-link';
    d.setAttribute('data-odx-link', '');
    var id = 'OdxLink-' + formId;
    d.innerHTML = '<label for="' + id + '">' + intro + ' <small>(Canva, Google Drive, Dropbox or WeTransfer)</small></label>' +
      '<input type="text" id="' + id + '" name="properties[Artwork link]" form="' + formId + '" placeholder="Paste your file link (https://)" inputmode="url" autocomplete="off" spellcheck="false">' +
      '<p class="odx-link__hint">Make sure the link is shared so anyone with it can view. Links also work for files over 20 MB.</p>';
    return d;
  }
  function linkValue(box) {
    var inp = box && box.querySelector('input');
    var v = inp ? inp.value.trim() : '';
    if (v && !/^https?:\/\//i.test(v) && /\./.test(v)) { v = 'https://' + v; inp.value = v; }
    return v;
  }
  function linkOk(v) { return /^https?:\/\/[^\s.]+\.[^\s]{2,}/i.test(v); }

  /* no template changes needed: find the main product form, mark the step headings, read prices from the product JSON */
  var SUB = /^(finish|upload\s*&\s*preview your artwork)$/i;
  function boot() {
    addStyle();
    ppTotal();
    var form = document.querySelector('.product__info-container form[id^="product-form-"]') || document.querySelector('form[id^="product-form-"]');
    if (!form || form.__odx) return;
    var info = form.closest('.product__info-container');
    if (!info || !info.querySelector('.odx-pdp-h')) return;
    form.__odx = true;
    Array.prototype.forEach.call(info.querySelectorAll('.odx-pdp-h'), function (h) {
      if (!SUB.test(h.textContent.trim())) h.setAttribute('data-odx-step', '');
    });
    var design = info.querySelector('[data-odx-design]');
    if (design && !design.getAttribute('data-price')) {
      var em = design.closest('label') && design.closest('label').querySelector('em');
      var m = em && /([\d,.]+)/.exec(em.textContent);
      if (m) design.setAttribute('data-price', Math.round(parseFloat(m[1].replace(/,/g, '')) * 100));
    }
    /* pages without our own uploader (Kixxl pages): offer a link box above Add to cart */
    if (!info.querySelector('[data-odx-bcu]') && !info.querySelector('[data-odx-link]')) {
      var pf = form.closest('product-form') || form;
      var fid = form.getAttribute('id');
      var or = document.createElement('p');
      or.className = 'odx-link__or'; or.textContent = 'or';
      var box = linkBox(fid, 'Already have your file? Paste a link and add to cart');
      var wrap = document.createElement('div');
      wrap.className = 'odx-pdp';
      wrap.appendChild(or); wrap.appendChild(box);
      pf.parentNode.insertBefore(wrap, pf);
      var err = document.createElement('p');
      err.className = 'odx-link__hint'; err.style.color = '#a3122f'; err.style.fontWeight = '700'; err.hidden = true;
      box.appendChild(err);
      document.addEventListener('submit', function (e) {
        if (e.target !== form) return;
        var v = linkValue(box), inp = box.querySelector('input');
        box.classList.remove('is-bad'); err.hidden = true;
        if (v && !linkOk(v)) {
          e.preventDefault(); e.stopImmediatePropagation();
          box.classList.add('is-bad'); err.textContent = 'Please paste the full link, starting with https://'; err.hidden = false;
          inp.focus();
          return;
        }
        if (!v) { inp.disabled = true; setTimeout(function () { inp.disabled = false; }, 1500); }
      }, true);
    }
    var handle = (/\/products\/([^\/?#]+)/.exec(location.pathname) || [])[1];
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    if (!handle) return;
    fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        init({
          sid: form.getAttribute('id').replace('product-form-', ''),
          currency: cur,
          everyFree: info.querySelector('[data-odx-promo]') ? 4 : 0,
          options: (p.options || []).map(function (o) { return o.name || o; }),
          variants: (p.variants || []).map(function (v) { return { id: v.id, p: v.price, o: v.options }; })
        });
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
